

import Vue from 'vue'

import VueI18n from "vue-i18n";
import moment from "moment";

import "moment/locale/ar";
import {LanguageJSON} from "@/languageJson/index"
import VuexStore from '../store'

let i18nObj;

let supportedLocales = [ "en","ar"];
const LANGUAGE="language"
const LanguageService = {
  getLanguage() {
    try {
      return localStorage.getItem(LANGUAGE)
        ? JSON.parse(localStorage.getItem(LANGUAGE))
        : null;
    } catch (err) {
      return null;
    }
  },

  saveLanguage(language) {
    localStorage.setItem(LANGUAGE, JSON.stringify(language));
  },

  removeLanguage() {
    localStorage.removeItem(LANGUAGE);
  }
};
Vue.use(VueI18n);
let loadedLanguages = [];

export function setI18nLanguage(lang) {
  i18nObj.locale = lang;
  // document.querySelector('html').setAttribute('lang', lang)
  moment.locale(supportedLocales.includes(lang) ? lang : "en");
  return lang;
}

export async function initi18n() {
  let lang;
  let savedLang = LanguageService.getLanguage();
  console.log("savedLang",savedLang)
  if (savedLang && savedLang.lang) {
    setTimeout(() => { VuexStore.commit('SET_CURRENT_LANGUAGE', savedLang) })
    console.log("found saved language = ", savedLang);
    lang = savedLang.lang.toLowerCase();
  } else {
    console.log("counldnt find saved lang. defaulting to en");
    lang = "en";
  }

     let messages = LanguageJSON;

      console.log("messages: ", messages);
      let i18nInstance = new VueI18n({
        locale: lang,
        fallbackLocale: lang,
        messages,
        silentTranslationWarn: true
      });
      console.log("messages: ", i18nInstance,messages);
      i18nObj = i18nInstance;
      setI18nLanguage(lang);
      return i18nInstance;

}

// export function loadLanguage(lang) {
//   lang = lang ? lang.toLowerCase() : "";
//   console.log("loadLanguage is called = ", lang);
//   console.log("loadedLanguages", loadedLanguages);
//   // If the language was already loaded
//   if (loadedLanguages.includes(lang)) {
//     return Promise.resolve(setI18nLanguage(lang));
//   }

//   return GlobalService.GetTranslations()
//     .then(resp => {
//       const { data } = resp;
//       let messages = {};
//       if (data.status) {
//         for (let key of Object.keys(data.Records)) {
//           loadedLanguages.push(key);
//           messages[key] = data.Records[key].translation;
//         }
//       }
//       setI18nLanguage(lang);
//       console.log("loadedLanguages: ", loadedLanguages);
//       console.log("messages: ", messages);
//       return messages;
//     })
//     .catch(function(error) {
//       console.log("error in loading translations");
//       console.log(error);
//     });
// }

export function geti18nObj() {
  return i18nObj;
}

export default initi18n;



// WEBPACK FOOTER //
// ./src/plugins/i18n.js